var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-select-container" },
    [
      _c(
        "el-select",
        {
          attrs: { "value-key": "company_id" },
          on: { change: _vm.chooseComapny },
          model: {
            value: _vm.selectedCompany,
            callback: function($$v) {
              _vm.selectedCompany = $$v
            },
            expression: "selectedCompany"
          }
        },
        _vm._l(_vm.choosedCompanyList, function(item) {
          return _c("el-option", {
            key: item.company_id,
            attrs: { label: item.company_name, value: item }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.showCompanyList } },
        [_vm._v("\n    选择单位\n  ")]
      ),
      _vm._v(" "),
      _c("CompanyListDialog", {
        attrs: { dialogVisible: _vm.companyListDialogVisible },
        on: {
          choose: _vm.chooseCompanyCb,
          "update:dialogVisible": function($event) {
            _vm.companyListDialogVisible = $event
          },
          "update:dialog-visible": function($event) {
            _vm.companyListDialogVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52d75083", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52d75083","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanySelect/CompanySelect.vue
// module id = null
// module chunks = 